export default __webpack_public_path__ + "static/media/instagram.c6f84398.svg";